import { render, staticRenderFns } from "./card-hsia-grid.vue?vue&type=template&id=c1dd97a8&scoped=true&"
import script from "./card-hsia-grid.vue?vue&type=script&lang=js&"
export * from "./card-hsia-grid.vue?vue&type=script&lang=js&"
import style0 from "./card-hsia-grid.vue?vue&type=style&index=0&id=c1dd97a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dd97a8",
  null
  
)

export default component.exports